import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { getAuthLoginUrl } from '../../../utils/externalPages';
import CircularProgress from '../CircularProgress';

const PrivateRoute = ({ component: CurrentComponent, ...rest }) => {
  const { authToken, loadedUser } = useSelector((state) => state.auth);

  const isAuthorized = useMemo(() => !isEmpty(authToken), [authToken]);

  useEffect(() => {
    if (!isAuthorized) {
      window.location.href = getAuthLoginUrl();
    }
  }, [isAuthorized]);

  if (!loadedUser) {
    return <CircularProgress style={{ height: '100vh' }} />;
  }

  return (
    <Route
      {...rest}
      render={() => (isAuthorized ? <CurrentComponent /> : null)}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default PrivateRoute;
